module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0006#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0007#ch01"
    }
  }, [_vm._v("ONE / Hallways and Airwaves: Changing Neighborhoods and Emerging Media Inspire New Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0008#ch02"
    }
  }, [_vm._v("TWO / I’m a-Telling You: Artists and Entrepreneurs Step Up in a New Decade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0009#ch03"
    }
  }, [_vm._v("THREE / We’re a Winner: Musicians, Activists, and Educators Build an Expanding Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0010#ch04"
    }
  }, [_vm._v("FOUR / Psychedelic Soul: Chicago’s 1960s Counterculture Redirects Social and Musical Cues")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0011#ch05"
    }
  }, [_vm._v("FIVE / A New Day: Afrocentric Philosophy and Sharp Statements Answer 1960s Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0012#ch06"
    }
  }, [_vm._v("SIX / Rhythm Ain’t All We Got: Organizational Drive Shapes 1970s Black Music, Commerce, and Politics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0014#ch07"
    }
  }, [_vm._v("SEVEN / Sound Power: Funk and Disco Highlight Connections, Divisions, and Aspirations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0015#ch08"
    }
  }, [_vm._v("EIGHT / Future Telling: Reissues, Sampling, and Young Artists Reconsider Soul History")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0013#gallery"
    }
  }, [_vm._v("Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0016#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0017#app"
    }
  }, [_vm._v("Appendix: Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0018#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0019#disco"
    }
  }, [_vm._v("Selected Discography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0020#sel_bib"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0021#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a02d8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-cohen-move-0005.vue
// module id = 66
// module chunks = 0